module.exports = __webpack_public_path__ + "static/media/videos.bd72a8ea.svg";